export const INVOICE_STATUSES = {
	1: "PENDIENTE",
	2: "EMITIDO",
	3: "RECHAZADO",
	4: "ERROR",
};
